export default __webpack_public_path__ + "images/gw-header-image.png?5643ebb38cd5dea87643a4a500ee0bf0";